import React from "react";
import "./S6VI.css";

// ✅ Import your background image
import heroJpg from "../../assets/VIhero.png";

const S6VI = ({
  title = "Ready to grow your retail business?",
  ctaText = "Get started",
  ctaHref = "https://www.maplee.ca/auth/sign-up?redirect=/vendor/apply",
}) => {
  return (
    <section
      className="s6vi"
      style={{ backgroundImage: `url(${heroJpg})` }} // 👈 uses imported image
      aria-labelledby="s6vi-title"
    >
      <div className="s6vi-overlay" />

      <div className="s6vi-inner">
        <h2 id="s6vi-title" className="s6vi-title">
          {title}
        </h2>

        <a className="s6vi-cta" href={ctaHref}>
          {ctaText}
        </a>
      </div>
    </section>
  );
};

export default S6VI;